<template>
  <section class="sidearm-mm-theme bg-black relative" data-anchor="theme">
    <div
      class="sidearm-mm-theme__bg absolute bg-size-cover bg-position-center"
      :style="background_transform"
    ></div>
    <div
      class="sidearm-mm-theme__inner relative w-100 h-100 flex flex-align-center flex-justify-center"
      id="sidearm-mm-theme-tracker"
    >
      <img :src="require(`@/assets/themes/chalk/${filename}.png`)" />
    </div>
  </section>
</template>

<script>
export default {
  props: ["value"],
  data: () => ({}),
  computed: {
    filename: function() {
      let s = "00" + this.value;
      return s.substr(s.length - 3);
    },
    background_transform: function() {
      return {
        transform: "translateY(" + this.value * -0.7 + "%)"
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.sidearm-mm-theme {
  &__bg {
    top: 0;
    left: 0;
    width: 100%;
    height: 120%;
    background-image: url("~@/assets/themes/chalk/bg.jpg");
    transition: transform 0.5s;
  }
  &__inner {
    padding-top: $header-height;
    img {
      max-height: 75%;
      opacity: 0.5;
    }
  }
}
</style>
